<template>
    <div>
        <el-card>
            <div slot="header" class="clearfix" style="text-align:center;">
                <a style="text-decoration:none;color:#337ab7;cursor:pointer; float: left; line-height: 36px;" @click="returnBack">返回</a>
                <span style="line-height: 36px;" v-if="editFlag==0">添加商品</span>
                <span style="line-height: 36px;" v-if="editFlag==1">编辑商品</span>
            </div>
            <div class="card-body" style="text-align:left;">
                <div class="item-list">

                  <p>
                      <span class="span_1" >商品名称：</span>
                      <el-input v-model="commodity.commodityName" style="width:200px;"></el-input>
                  </p>
                  <!--<p>
                      <span class="span_1" >商品类型：</span>

                      <el-select style="width:200px;" v-model="commodity.commodityType" placeholder="请选择商品类型">
                          <el-option label="设备" value="1"></el-option>
                          <el-option label="纸巾" value="2"></el-option>
                          <el-option label="其他" value="3"></el-option>
                      </el-select>

                  </p>-->

                  <p>
                      <span class="span_1">是否上架：</span>
                      <el-switch
                            v-model="bOnSale"
                            active-color="#13ce66"
                            inactive-color="#dddddd"
                            active-value="1"
                            inactive-value="0"
                            >
                            </el-switch>


                  </p>

                  <p>
                      <span class="span_1">价格(分)：</span>
                      <el-input v-model="commodity.commodityPrice" style="width:200px;"></el-input>
                  </p>
                  <p>
                      <span class="span_1">单位：</span>
                      <el-input v-model="commodity.goodsUnit" style="width:200px;"></el-input>
                  </p>

                  <p>
                      <span class="span_1" >告警数量：</span>
                      <el-input v-model="commodity.warningCount" style="width:200px;"></el-input>
                  </p>
                 <!-- <p>
                      <span class="span_1">已售数量：</span>
                      <el-input v-model="commodity.saleCount" style="width:200px;"></el-input>
                  </p>-->

                  <p>
                      <span class="span_1">商品缩略图：</span>
                      <el-upload
                          ref="upload"
                          class="upload-demo"
                          action="http://upload.qiniu.com/"
                          :data="myForm"
                          method="post"
                          :on-preview="handlePreview"
                          :show-file-list="false"
                          :before-upload="handleBeforeUpload"
                          :on-success="handleSuccess"
                          :multiple="isMultiple"
                          :file-list="fileList1">
                          <el-button size="small" type="primary" @click="ctrlType(0)">选择文件</el-button>
                      </el-upload>
                      <br>
                      <img :src="commodity.commodityIcon" style="width:200px;margin-left:250px;">
                  </p>

                  <p>
                      <span class="span_1">商品相册图：</span>

                      <el-upload
                          ref="upload"
                          class="upload-demo"
                          action="http://upload.qiniu.com/"
                          :data="myForm"
                          method="post"
                          :on-preview="handlePreview"
                          :show-file-list="false"
                          :before-upload="handleBeforeUpload"
                          :on-success="handleSuccess"
                          :multiple="isMultiple"
                          :file-list="fileList2">
                          <el-button size="small" type="primary" @click="ctrlType(1)">添加图片</el-button>
                      </el-upload>


                     <div v-if="commodityGallerys.length >0" style="margin-left:250px;">

                        <div v-for="(image,key) in commodityGallerys" v-if="image!=''" style="display: inline;width: 200px;">

                           <img :src="image" @click='delImage(key)' style="width:200px;"/>
                           <a href="#" style="position: absolute; margin-left:-30px;margin-top:10px; color:#000;" @click='delImage(key)' >
                              <span class="el-icon-close"></span>
                          </a>
                        </div>
                    </div>


                  </p>

                  <p>
                      <span class="span_1">图文详情：</span>
                      <!--<el-input v-model="commodity.commodityDesc" style="width:200px;"></el-input>-->
                      <UEditor :config=config ref="ueditor"></UEditor>
                  </p>

                </div>


                <div style="text-align: center">
                    <el-button class="item-right" type="info" :loading="btnLogin" @click="btnSave()">保存</el-button>
                </div>
            </div>
        </el-card>
    </div>
</template>
<script>
  import $ajax from '../../https/config'

  import {getQueryString, isNull} from '../../js/tool'

  import UEditor from '@/components/ueditor/ueditor.vue'

  export default {
    data () {
      return {
        commodity:{
          id:0,
          commodityName:'',
          commodityType:0,
          commodityPrice:0,
          commodityOnsale:1,
          leftCount:999,
          saleCount:200,
          commodityIcon:'',
          commodityGallery:'',
          commodityDesc:''
        },
        btnLogin:false,
        editFlag:0,
        bOnSale:true,
        isMultiple: true,
        fileList1: [],
        fileList2: [],
        img1: '',
        img2: '',
        form: {},
        commodityGallerys:[],
        config: {
            //可以在此处定义工具栏的内容
            // toolbars: [
            //  ['fullscreen', 'undo', 'redo','|','bold', 'italic', 'underline',
            //  '|','superscript','subscript','|', 'insertorderedlist', 'insertunorderedlist',
            //  '|','fontfamily','fontsize','justifyleft','justifyright','justifycenter','justifyjustify']
            // ],
            autoHeightEnabled: false,
            autoFloatEnabled: true,
            initialContent:'',   //初始化编辑器的内容,也可以通过textarea/script给值，看官网例子
            autoClearinitialContent:true, //是否自动清除编辑器初始内容，注意：如果focus属性设置为true,这个也为真，那么编辑器一上来就会触发导致初始化的内容看不到了
            initialFrameWidth: null,
            initialFrameHeight: 450,
            BaseUrl: '',
            UEDITOR_HOME_URL: 'static/ueditor/'
          },
          addFormVisible: false
      }
    },
    computed: {
      myForm: {
        set: function (value) {
          this.form = value
        },
        get: function () {
          return this.form
        }
      }
    },
    created: function () {
      this.getCommodityDetail()
      this.getUpToken ()

    },
    methods: {
      convertCommodity2MutiGoods (commodity) {
        var mutiGoods = commodity;
        mutiGoods.goodsName = commodity.commodityName;
        mutiGoods.goodsIcon = commodity.commodityIcon;
        mutiGoods.goodsPrice = commodity.commodityPrice;
        return mutiGoods;
      },
      convertMutiGoods2Commodity (mutiGoods) {
        var commodity = mutiGoods;
        commodity.commodityName = commodity.goodsName;
        commodity.commodityIcon = commodity.goodsIcon;
        commodity.commodityPrice = commodity.goodsPrice;
        return commodity;
      },
      getCommodityDetail: function () {
        var commodityId = getQueryString('commodityId')
        if (isNull(commodityId)){
          return
        }

        var _this = this

        _this.editFlag = 1;
        var userInfoStr = sessionStorage.getItem('lbz-device-user-info')
        var userInfo =  JSON.parse(userInfoStr)
        var url = '/mutigoods/queryDetail'
        var params = {
          owner :userInfo.owner,
          commodityId:commodityId
        }



        $ajax.get(url, params, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            _this.commodity = res.resultData
            _this.bOnSale = res.resultData.commodityOnsale==1?true:false

            _this.commodityGallerys = _this.commodity.commodityGallery.split(';');


            _this.commodity = _this.convertMutiGoods2Commodity(_this.commodity);

          

            _this.$refs.ueditor.setReadyFunc(function() {
              //console.log("ueditorueditorueditorueditorueditor")
                _this.$refs.ueditor.setContent(_this.commodity.commodityDesc) //赋值给UEditor
            })
            //_this.$refs.ueditor.setContent(res.resultData.commodityDesc)

          }
        }, function () {})
      },
      getUpToken () {
        var myUrl =  'http://platform.songzb.com:32000/qiniuToken/image'
        var _this = this
        $ajax.get(myUrl, '', '', function (res) {
          _this.form.token = res.uptoken
        }, function () {
        })
      },
      handlePreview (file) {
      },
      handleBeforeUpload (file) {
        var last
        last = file.name.split('.').pop()
        if (last !== 'jpg' && last !== 'png' && last !== 'jpeg') {
          this.$message({
            type: 'error',
            message: '图片格式错误'
          })
          return false
        }
        var str = 'spgallery-' + (new Date().getTime()) + Math.ceil(Math.random() * 10) + '.' + last
        this.form.key = str
      },
      handleSuccess (response, file, fileList) {
        if (this.myType === 0) {
          //this.img1 = 'http://res.songzb.com/' + response.key
          this.commodity.commodityIcon = 'http://image.songzb.com/' + response.key
        } else {
          //this.img2 = 'http://image.songzb.com/' + response.key
          this.commodityGallerys.push('http://image.songzb.com/' + response.key);
        }
      },
      ctrlType (type) {
        if (type === 0) {
          this.myType = 0
        } else {
          this.myType = 1
        }
      },
      delImage (key){
        var _this = this;
        var tCommodityGallerys = [];
        for (var i=0; i<_this.commodityGallerys.length; i++){
          //console.log(_this.commodityGallerys[i]);
          if (key==i){

          }else{
            if (!isNull(_this.commodityGallerys[i])){
              tCommodityGallerys.push(_this.commodityGallerys[i]);
            }
          }
        }
        _this.commodityGallerys = tCommodityGallerys;
      },
      btnSave: function () {
        var _this = this
        var url = '/mutigoods/add'

        if (this.editFlag==1){
          url = '/mutigoods/update'
        }

        _this.commodity.commodityOnsale = (_this.bOnSale?1:0)
        _this.commodity.commodityGallery = _this.commodityGallerys.join(";")
        //var params = _this.commodity

        var params = Object.assign(_this.commodity, 
          {
            goodsName:_this.commodity.commodityName,
            goodsIcon:_this.commodity.commodityIcon,
            goodsPrice:_this.commodity.commodityPrice,
          });

        let content = this.$refs.ueditor.getContent()
        console.log(content);
        _this.commodity.commodityDesc = content

        $ajax.post(url, params, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            _this.$message({
              type: 'success',
              message: '保存商品成功!'
            })
            setTimeout(function () {
              _this.btnLogin = false
              //_this.returnBack()
              //this.$router.go(0)
            }, 1000)
          } else {
            _this.$message({
              type: 'error',
              message: '保存商品失败!' + res.errorMessage
            })
            _this.btnLogin = false
          }
        })
      },
      returnBack () {
        this.$router.back(-1)
      }
    },
    components: {
      UEditor
    }
  }
</script>
<style lang="scss">
    .card-body .item-list:nth-child(n+2) {
        margin-top: 20px;
    }
    .upload-demo {

        margin-bottom:  10px;
        display: inline-block;
    }
    .span_1{
            display: inline-block;
            width: 250px;

          }

    .item-list {
        display: inline-block;
        width: 100%;

        .item-left, .item-right {
            float: left;
            text-align: left;

        }

        .item-left {
             margin-right: 30px;
            span {
                vertical-align:sub;
                vertical-align:-webkit-baseline-middle;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/mutiGoods/mutiGoodsAdd.vue